import { createResourceRequests } from '../../helpers/resource';
import * as normalizers from './normalizers';

const latest = () => ({
  method: 'GET',
  url: 'api/tnevents/upcoming',
  normalizer: normalizers.fromLatest,
});

const show = ({ id }) => ({
  method: 'GET',
  url: `/api/tnevents/${id}`,
  normalizer: normalizers.fromShow,
});

const tickets = ({ id, params }) => ({
  method: 'GET',
  url: `/api/tnevents/${id}/tickets/browse`,
  normalizer: normalizers.fromTickets,
  rootData: {
    id,
  },
  params: normalizers.toTicketsCurated(params),
});

const ticketsCurated = ({ id, params }) => ({
  method: 'GET',
  url: `/api/tnevents/${id}/tickets/recommended`,
  normalizer: normalizers.fromTicketsCurated,
  rootData: {
    id,
  },
  params: normalizers.toTicketsCurated(params),
});

const endpoints = {
  latest,
  show,
  tickets,
  ticketsCurated,
};

const api = createResourceRequests(endpoints);

export default api;



// WEBPACK FOOTER //
// ./src/resources/events/api.js